module.exports = __webpack_public_path__ + "img/jerusalem-large.4305abc6.jpg";